import * as actionTypes from '../action-types';
import { reqByGet } from '@/api/api';
import servers from '../../api/server';


export const updateBadge = (callback) => {
    return async dispatch => {
        reqByGet(servers.fristTO, {}, res => {
            if (res.statusCode === 1000) {
                dispatch({
                    type: actionTypes.BADHE_NUM,
                    data: res,
                });
                if (callback) {
                    console.log(callback)
                    callback(res)
                }
            };
        }, err => {
            console.log(err)
        })
    }
}
